// components/Hero.jsx
import React, { useState } from 'react';
import train from "../../assets/train.png";
import Logo from "../../assets/inovact.png";
import pmi from "../../assets/pmi.png";
import pmp from "../../assets/pmp1.png";
import "../CSS/LandingHero.css";
import EligibilityModal from '../../components/EligibilityModal';

const PmpHeroSection = ({ scrollToCalendar, openEligibilityModal }) => {
  const [showEligibilityModal, setShowEligibilityModal] = useState(false);

  const handleEligibilityComplete = (results) => {
    console.log('Résultats du questionnaire:', results);
    setShowEligibilityModal(false);

    // Rediriger vers l'inscription si recommandation PMP
    if (results.recommendation.certification === 'PMP') {
      scrollToCalendar();
    }
  };

  return (
    <>
      <div className="landing-hero-section">
        {/* Conteneur de la bannière */}
        <div className="landing-hero-banner">
          {/* Image de fond */}
          <img
            src={train}
            alt=""
            loading="lazy"
            className="landing-hero-image landing-hero-image-animation"
          />

          {/* Overlay */}
          <div className="landing-hero-overlay"></div>

          {/* Contenu centré */}
          <div className="landing-hero-content landing-hero-content-container">

            <div className="landing-hero-title landing-title1 ">
              <a
                href="https://www.credly.com/badges/ada65326-d394-4cf7-91a7-35956cb7a384/public_url"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="landing-logo-img1" src={pmi} loading="lazy" alt="Logo PMI" />
              </a>
            </div>

            {/* Titre principal */}
            <h1 className="landing-hero-title landing-hero-title-animation">
              <span className="landing-title-white">
                Pourquoi les certifiés PMP gagnent-ils plus et ont{' '}
              </span>
              <br />
              <span className="landing-title-white">plus d'opportunités ?</span>
            </h1>

            {/* Description */}
            <p className="landing-hero-description landing-hero-description-animation">
              Inscrivez-vous dès maintenant et bénéficiez d'un tarif sponsorisé.
            </p>

            {/* Boutons CTA */}
            <div className="landing-hero-buttons landing-hero-buttons-animation">
              <button
                className="landing-hero-btn landing-hero-btn-secondary"
                style={{ width: 'auto' }}
                onClick={openEligibilityModal}
              >
                Vérifier votre éligibilité
              </button>
              <button
                className="landing-hero-btn landing-hero-btn-primary"
                style={{ width: 'auto' }}
                onClick={scrollToCalendar}
              >
                Voir calendrier et tarif
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal d'éligibilité */}
      <EligibilityModal
        isOpen={showEligibilityModal}
        onClose={() => setShowEligibilityModal(false)}
        onComplete={handleEligibilityComplete}
      />
    </>
  );
};

export default PmpHeroSection;